// var videojs = require('video.js');
import videojs from 'video.js';
window.videojs = videojs;
// require('videojs-contrib-dash');
// require('videojs-contrib-ads');
// require('videojs-ima');
import 'videojs-contrib-dash'
import 'videojs-contrib-ads'
import 'videojs-ima'